/*
 * Botones de navegacion entre las vistas del Dashboard: Home y Tablas
 */
import { Box, Button, Flexbox } from "codekit";

/**
 * Renderiza los botones que alternan la vista del Dashboard
 * @param {Object} props Propiedades del componente
 * @param {string} props.currentView Vista activa actualmente (HOME o TABLEROS)
 * @param {Function} props.handleCurrentView Funcion que cambia la vista activa
 */
const Buttonsx = ({ currentView, handleCurrentView }) => {
  const views = [
    { id: "HOME", label: "Home" },
    { id: "TABLEROS", label: "Tableros" },
  ];

  return (
    <Box spacing={4} mb={4} borderBottom={1} borderColor="neutral-300">
      <Flexbox justifyContent="center" gap={1}>
        {views.map((view) => (
          <Button
            key={view.id}
            type="button"
            variant={currentView === view.id ? "secondary-bold" : "secondary"}
            size="m"
            onClick={() => handleCurrentView(view.id)}
          >
            {view.label}
          </Button>
        ))}
      </Flexbox>
    </Box>
  );
};

export default Buttonsx;
